
<div style="display: flex; justify-content: space-between; background: white;">
<np-header class="headerClass" [hasEnterpriseSearch]="false" sitename="Planning Workspace">
</np-header>
 <div class="header-content-right" style="display: flex;align-items: center;">
    <p-select
      [options]="dropdownOptions"
      [(ngModel)]="selectedActivePlan"
      optionLabel="label"
      optionValue="id"
      class="plan-dropdown"
      [showClear]="false"
      (onChange)="onActivePlanChange($event.value)"
      placeholder="Select Active Plan"
    ></p-select>
    <div class="welcome-info" *ngIf="welcomeName">
      <h5 class="welcome-text">Welcome, {{ welcomeName }}</h5>
      <div *ngIf="regionValue && displayRegionValue" class="region-role-info clickable-region-role" (click)="navigateToModel()">
        [ {{ regionValue }} | {{ displayRegionValue }} ]
      </div>
    </div>
  </div>
</div>
<div class="page-container">
  <div class="content-wrapper">
    <div class="location-content">
      <p-toast position="top-right" [baseZIndex]="1000000"></p-toast>
      <app-publish-plan-progress></app-publish-plan-progress>
      <router-outlet></router-outlet>
    </div>
  </div>

  <div class="footer-container">
    <np-footer [opCoName]="'Application Support Request Form'"
      [opCoUrl]="'https://chevron.service-now.com/mychevron?id=sc_cat_item_guide&sys_id=9c08a21edb126450182e1dca48961981'"
      [contentContactName]="'Neeta Aggarwal'" [contentContactUrl]="'mailto:neetaaggarwal@chevron.com'"
      [technicalContactName]="'Application & Platform Engineering Services'"
      [technicalContactUrl]="'mailto:cscm_integrated_planning_news@chevron.com'">
    </np-footer>
  </div>
</div>

<app-loader></app-loader>